/**
 * iter233 — Types de références / en-têtes proposés sur un OR.
 * Source unique côté front (miroir de backend/or_references.py).
 */
export const REFERENCE_TYPES = [
  { key: "no_sinistre", label: "N° de sinistre" },
  { key: "reference_vehicule", label: "Référence véhicule" },
  { key: "no_autorisation", label: "N° d'autorisation" },
  { key: "no_intervention", label: "N° d'intervention" },
  { key: "no_commande", label: "N° de commande" },
  { key: "no_police", label: "N° de police" },
];

export const SINISTRE_KEY = "no_sinistre";
export const FREE_KEY = "libre";

export const getReference = (references, key) => {
  const hit = (references || []).find((r) => r.key === key);
  return hit ? (hit.value || "") : "";
};
